<template>
  <ScreenHeader>
    <div class="chart-container">
      <div class="upperHalf mb-6">
        <div class="leftHalf">
          <div class="leftTopHalf TopHalf mb-6">
            <div class="title mb-34">员工概况</div>
            <div class="chart flex align-center">
              <DynamicCircularRing :outerRingDiameter="138" animation>
                <div class="totalDetail flex-center">
                  <div class="top">
                    <count-to :start-val="0" :end-val="evaluatorNum(staffTotal)" :decimals="countToDecimal(staffTotal)" :duration="3000" class="total countNumber" />
                    <span v-if="Number(staffTotal) >= 10000" class="unit">万</span>
                  </div>
                  <div class="text">员工总数(人)</div>
                </div>
              </DynamicCircularRing>
              <div class="detail ml-69">
                <div v-for="(item, index) in staffDetailLists" :key="index" class="item flex align-center" :class="{ 'mb-22': index !== staffDetailLists.length - 1 }">
                  <div class="left flex align-center">
                    <img :src="item.icon" alt="" class="icon mr-11" />
                    <span class="text">{{ item.title }}</span>
                  </div>
                  <div class="right">
                    <img src="./assets/img/line.png" alt="" class="line" />
                    <div class="amount">{{ evaluatorNum(item.amount) }}</div>
                    <div class="unit">{{ evaluatorUnit(item.amount, item.unit) }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="leftBottomHalf BottomHalf">
            <div class="title mb-17">岗位概况</div>
            <div id="chart-post">
              <div v-for="(item, index) in postData" :key="index" class="list">
                <div class="left">
                  <span class="label">{{ item.postName }}</span>
                  <HorizontalBarChart :key="`post${index}`" :percentage="item.total / staffTotal" :apertureColor="item.apertureColor" :lineWidth="335" :color="item.color" />
                </div>
                <div class="right flex-auto ml-14">
                  <span class="value">{{ evaluatorNum(item.total) }}</span>
                  {{ evaluatorUnit(item.total, '人') }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="centerHalf">
          <div class="centerTopHalf">
            <div v-for="(item, index) in groupData" :key="index" class="groupDataItem">
              <img :src="item.icon" alt="" class="icon" />
              <div class="groupDataItem-left">
                <div>
                  <span class="amount">{{ evaluatorNum(item.amount) }}</span>
                  <span v-if="Number(item.amount) >= 10000" class="unit">万</span>
                </div>
                <span class="title">{{ item.title }}</span>
              </div>
            </div>
          </div>
          <div class="centerBottomHalf">
            <ChinaChart v-if="showChina" :data="organizationStatList.mapStat" @changeProvince="changeProvince" />
            <IdentityMap v-else :provinceName="provinceName" :province="province" @goBack="goBack" />
          </div>
        </div>
        <div class="rightHalf">
          <div class="rightTopHalf TopHalf mb-6">
            <div class="title mb-32">住户统计</div>
            <div class="chart flex align-center">
              <div class="detail">
                <div
                  v-for="(item, index) in householdStatisticsRate"
                  :key="index"
                  class="item flex align-center"
                  :class="{ 'mb-22': index !== householdStatisticsRate.length - 1 }"
                >
                  <div class="left flex align-center">
                    <img :src="item.icon" alt="" class="icon mr-11" />
                    <span class="text">{{ item.label }}</span>
                  </div>
                  <div class="right">
                    <img src="./assets/img/line.png" alt="" class="line" />
                    <span class="amount">{{ item.value }}%</span>
                  </div>
                </div>
              </div>
              <CircularPieChart :data="householdStatistics" :ringWidth="3" :gapContent="10" :ringSize="138" animation>
                <div class="chart-inner-content houseHoldChart flex-center">
                  <div class="top">
                    <count-to :start-val="0" :end-val="evaluatorNum(householdTotal, 0)" :duration="3000" class="total countNumber" />
                    <span v-if="Number(householdTotal) >= 10000" class="unit">万</span>
                  </div>
                  <div class="text">住户总数(人)</div>
                </div>
              </CircularPieChart>
            </div>
          </div>
          <div class="rightBottomHalf BottomHalf">
            <div class="title mb-17">服务概况</div>
            <div class="chart-service">
              <div v-for="(item, index) in serviceData" :key="index" class="list flex align-center">
                <div class="left flex align-center">
                  <div class="label">{{ item.postName }}</div>
                  <HorizontalBarChart
                    :key="`service${index}`"
                    :percentage="item.total / serviceDataTotal"
                    :apertureColor="item.apertureColor"
                    :lineWidth="315"
                    :color="item.color"
                  />
                </div>
                <div class="value ml-14">
                  <span class="total">{{ evaluatorNum(item.total, 0) }}</span>
                  <span class="unit">{{ evaluatorUnit(item.total, '次') }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="lowerPart flex align-center">
        <div class="lowerLeftPart flex-between">
          <div class="left">
            <div class="title">收费情况</div>
            <div class="bottomLeft">
              <div class="situation flex-between">
                <div v-for="(item, index) in feeSituation" :key="index" class="item">
                  <div class="mb-4">
                    <span class="amount">{{ evaluatorNum(item.amount) }}</span>
                    <span class="unit">{{ evaluatorUnit(item.amount, '元') }}</span>
                  </div>
                  <div class="text">{{ item.title }}</div>
                </div>
              </div>
              <div class="charts">
                <DynamicCircularRing
                  v-for="(item, index) in payList"
                  :key="index"
                  :point="false"
                  innerRingBackgroundColor="#031F5E"
                  :targetDeg="(360 / Number(totalFeeAmount).toFixed(0)) * Number(item.amount).toFixed(0)"
                  :outerRingDiameter="123"
                  :innerRingDiameter="106"
                  :roundColor="item.roundColor"
                >
                  <div class="chart-inner-content flex-center">
                    <div class="top">
                      <count-to :start-val="0" :end-val="evaluatorNum(item.amount)" :decimals="countToDecimal(item.amount)" :duration="3000" class="total countNumber" />
                      <span v-if="Number(item.amount) >= 10000" class="unit">万</span>
                    </div>
                    <div class="text">{{ item.title }}</div>
                  </div>
                </DynamicCircularRing>
              </div>
            </div>
          </div>
          <!-- <div class="table">
            <div class="table-header text">
              <div class="column-1">收费排行榜</div>
              <div class="column-2">项目名称</div>
              <div class="column-3">收费金额</div>
            </div>
            <div class="gap"></div>
            <template v-if="organizationStatList.communityOrders && organizationStatList.communityOrders.length">
              <div v-for="(item, index) in organizationStatList.communityOrders" :key="index" class="table-row row">
                <div class="column-1">
                  <div class="rank" :class="{ firstly: index === 0, second: index === 1, third: index === 2 }">{{ index + 1 }}</div>
                </div>
                <div class="column-2 text">{{ item.communityName || '-' }}</div>
                <div class="column-3">
                  <span class="amount color">{{ evaluatorNum(item.realAmount) }}</span>
                  <span class="unit color">{{ evaluatorUnit(item.realAmount, '元') }}</span>
                </div>
              </div>
            </template>
            <div v-else class="empty">
              <img src="./assets/img/empty.png" alt="" />
            </div>
          </div> -->
          <ScrollTable :data="organizationStatList.communityOrders" />
        </div>
        <div class="lowerRightPart">
          <div class="title mb-22">房屋概况</div>
          <div class="chart flex-between">
            <CircularPieChart :data="outData" :ringWidth="2" :ringSize="180" :gapContent="16" :gapDeg="0" gradientType="gradient">
              <CircularPieChart :data="houseOverview" :ringWidth="6">
                <div class="context">
                  <div class="chart-inner-content flex-center">
                    <div class="top">
                      <count-to :start-val="0" :end-val="evaluatorNum(HousesTotal, 0)" :duration="3000" class="total countNumber" />
                      <span v-if="Number(HousesTotal) >= 10000" class="unit">万</span>
                    </div>
                    <div class="text">房屋总数(套)</div>
                  </div>
                  <div
                    v-for="item in 20"
                    :key="item"
                    class="strip__wrapper"
                    :style="{
                      rotate: `${(item * 360) / 20}deg`,
                    }"
                  >
                    <div class="strip" />
                  </div>
                </div>
              </CircularPieChart>
            </CircularPieChart>
            <div class="detail">
              <div v-for="(item, index) in houseOverviewRate" :key="index" class="item flex align-center" :class="{ 'mb-10': index !== houseOverview.length - 1 }">
                <div class="left">
                  <div :style="{ backgroundColor: item.color }" class="dot"></div>
                  <span class="text">{{ item.label }}</span>
                </div>
                <div class="right">
                  <div class="line"></div>
                  <span class="amount">{{ item.value }}%</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ScreenHeader>
</template>

<script>
import CountTo from 'vue-count-to'
import { organizationStat } from '@/api/dataScreen'
import ScreenHeader from './components/ScreenHeader'
import DynamicCircularRing from './components/DynamicCircularRing'
import HorizontalBarChart from './components/HorizontalBarChart'
import CircularPieChart from './components/CircularPieChart'
import ChinaChart from './components/ChinaChart'
import IdentityMap from './components/IdentityMap'
import ScrollTable from './components/ScrollTable'
import { evaluatorNum, evaluatorUnit, countToDecimal } from './assets/js/dataUtil'
export default {
  components: { ScreenHeader, ScrollTable, DynamicCircularRing, IdentityMap, HorizontalBarChart, CircularPieChart, CountTo, ChinaChart },
  data() {
    return {
      timer: null,
      showChina: true, // 显示中国地图
      provinceName: '',
      province: '',
      evaluatorNum,
      evaluatorUnit,
      countToDecimal,
      organizationStatList: {},
      // 饼图数据
      optionData: [],
      // 员工概况详情
      staffTotal: 0,
      staffDetailLists: [
        {
          title: '今日出勤',
          amount: 0,
          unit: '人',
          icon: require('./assets/img/attendance.png'),
        },
        {
          title: '男性员工',
          amount: 0,
          unit: '人',
          icon: require('./assets/img/man.png'),
        },
        {
          title: '女性员工',
          amount: 0,
          unit: '人',
          icon: require('./assets/img/female.png'),
        },
      ],
      // 岗位概况
      postData: [
        {
          postName: '项目经理',
          total: 0,
          apertureColor: 'rgba(30, 175, 244, 0.4706)',
          color: '#0FA2FD',
          key: 'projectManager',
        },
        {
          postName: '客服人员',
          total: 0,
          apertureColor: 'rgba(30, 175, 244, 0.4706)',
          color: '#1BD2F7',
          key: 'call',
        },
        {
          postName: '维修人员',
          total: 0,
          apertureColor: 'rgba(53, 238, 192, 0.49)',
          color: '#35EEC0',
          key: 'change',
        },
        {
          postName: '保洁人员',
          total: 0,
          apertureColor: 'rgba(30, 175, 244, 0.4706)',
          color: '#0FA2FD',
          key: 'clean',
        },
        {
          postName: '保安人员',
          total: 0,
          apertureColor: 'rgba(53, 238, 192, 0.49)',
          color: '#35EEC0',
          key: 'keep',
        },
        {
          postName: '绿化人员',
          total: 0,
          apertureColor: 'rgba(30, 175, 244, 0.4706)',
          color: '#1BD2F7',
          key: 'green',
        },
        {
          postName: '其他人员',
          total: 0,
          apertureColor: 'rgba(53, 238, 192, 0.49)',
          color: '#35EEC0',
          key: 'other',
        },
      ],
      // 服务概况
      serviceDataTotal: 0,
      serviceData: [
        {
          postName: '巡更次数',
          total: 0,
          apertureColor: 'rgba(30, 175, 244, 0.4706)',
          color: '#0FA2FD',
        },
        {
          postName: '巡检次数',
          total: 0,
          apertureColor: 'rgba(30, 175, 244, 0.4706)',
          color: '#1BD2F7',
        },
        {
          postName: '维保次数',
          total: 0,
          apertureColor: 'rgba(53, 238, 192, 0.49)',
          color: '#35EEC0',
        },
        {
          postName: '保洁次数',
          total: 0,
          apertureColor: 'rgba(30, 175, 244, 0.4706)',
          color: '#0FA2FD',
        },
        {
          postName: '保绿次数',
          total: 0,
          apertureColor: 'rgba(53, 238, 192, 0.49)',
          color: '#35EEC0',
        },
      ],
      // 集团统计数据
      groupData: [
        {
          title: '覆盖城市(个)',
          amount: 0,
          icon: require('./assets/img/city.png'),
        },
        {
          title: '管理总面积(m²)',
          amount: 0,
          icon: require('./assets/img/area.png'),
        },
        {
          title: '项目总数(个)',
          amount: 0,
          icon: require('./assets/img/project.png'),
        },
        {
          title: '楼栋总数(栋)',
          amount: 0,
          icon: require('./assets/img/building.png'),
        },
        {
          title: '车场总数(个)',
          amount: 0,
          icon: require('./assets/img/park.png'),
        },
        {
          title: '车位总数(个)',
          amount: 0,
          icon: require('./assets/img/parkingSpace.png'),
        },
        {
          title: '车辆总数(辆)',
          amount: 0,
          icon: require('./assets/img/car.png'),
        },
        {
          title: '设备总数(个)',
          amount: 0,
          icon: require('./assets/img/device.png'),
        },
      ],
      // 住户统计
      householdTotal: 0,
      householdStatistics: [
        {
          label: '老年人',
          value: 0,
          color: '#A5E9E7',
        },
        {
          label: '婴幼儿',
          value: 0,
          color: '#A5E9E7',
        },
        {
          label: '其他',
          value: 0,
          color: '#A5E9E7',
        },
      ],
      householdStatisticsRate: [
        {
          label: '老年人',
          value: 0,
          icon: require('./assets/img/oldPeople.png'),
        },
        {
          label: '婴幼儿',
          value: 0,
          icon: require('./assets/img/infant.png'),
        },
        {
          label: '其他',
          value: 0,
          icon: require('./assets/img/other.png'),
        },
      ],
      // 房屋概况
      houseOverviewRate: [
        {
          label: '未售',
          value: 0,
          color: '#74A1E3',
        },
        {
          label: '已售',
          value: 0,
          color: '#0DB0EE',
        },
        {
          label: '交房',
          value: 0,
          color: '#BF9A53',
        },
        {
          label: '入住',
          value: 0,
          color: '#49E6EA',
        },
        {
          label: '出租',
          value: 0,
          color: '#BCBDBD',
        },
        {
          label: '空置',
          value: 0,
          color: '#1DEFC8',
        },
      ],
      houseOverview: [
        {
          label: '未售',
          value: 0,
          color: '#74A1E3',
        },
        {
          label: '已售',
          value: 0,
          color: '#0DB0EE',
        },
        {
          label: '交房',
          value: 0,
          color: '#BF9A53',
        },
        {
          label: '入住',
          value: 0,
          color: '#49E6EA',
        },
        {
          label: '出租',
          value: 0,
          color: '#BCBDBD',
        },
        {
          label: '空置',
          value: 0,
          color: '#1DEFC8',
        },
      ],
      outData: new Array(4).fill({ value: 100, color: '#0AA7FF' }),
      HousesTotal: 0,
      // 收费情况
      totalFeeAmount: 0,
      payList: [
        {
          amount: 0,
          title: '线上缴费(元)',
          roundColor: '#0FA2FD',
        },
        {
          amount: 0,
          title: '线下缴费(元)',
          roundColor: '#1BD2F7',
        },
      ],
      feeSituation: [
        {
          title: '本年实收',
          amount: 0,
        },
        {
          title: '本年优惠',
          amount: 0,
        },
        {
          title: '本年退款',
          amount: 0,
        },
        {
          title: '本月实收',
          amount: 0,
        },
      ],
    }
  },
  mounted() {},
  created() {
    this.getList()
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    goBack() {
      this.showChina = true
      this.province = ''
      this.provinceName = ''
    },
    changeProvince(item) {
      this.showChina = false
      this.province = item.province
      this.provinceName = item.provinceName
    },
    // 获取数据
    async getList() {
      const { data } = await organizationStat()
      if (JSON.stringify(data) === JSON.stringify(this.organizationStatList)) return
      this.organizationStatList = data || {}
      if (!data) return
      this.dataInit(data)
      if (this.timer) return
      this.timer = setInterval(() => {
        this.getList()
      }, 3000)
    },

    // 初始化数据
    dataInit(data) {
      // 员工概况
      if (data.saasUserStat) {
        const key = ['attendanceCountThisDay', 'malePercent', 'femalePercent']
        this.staffTotal = 0
        key.forEach((item, index) => {
          this.staffDetailLists[index].amount = data.saasUserStat[item] || 0
          if (item !== 'attendanceCountThisDay') this.staffTotal += parseInt(data.saasUserStat[item])
        })
      }

      //岗位概况
      if (data.staffPositionStat) {
        this.postData.forEach(item => {
          item.total = data.staffPositionStat[item.key] || 0
        })
      }

      // 服务概况
      this.serviceData[0].total = data.patrolCount || 0
      this.serviceData[1].total = data.inspectCount || 0
      this.serviceData[2].total = data.maintainCount || 0
      this.serviceData[3].total = data.cleanCount || 0
      this.serviceData[4].total = data.greenCount || 0
      this.serviceDataTotal = 0
      this.serviceData.forEach(item => (this.serviceDataTotal += item.total))

      // 集团统计数据
      if (data.projectStat) {
        this.groupData[0].amount = data.projectStat.cityCount || 0
        this.groupData[1].amount = data.projectStat.manageArea || 0
        this.groupData[2].amount = data.projectStat.projectCount || 0
        this.groupData[3].amount = data.projectStat.buildingCount || 0
        this.groupData[4].amount = data.projectStat.parkingCount || 0
        this.groupData[5].amount = data.projectStat.parkingSpaceCount || 0
        this.groupData[6].amount = data.projectStat.parkingCarCount || 0
        this.groupData[7].amount = data.projectStat.deviceCount || 0
      }

      // 住户统计
      if (data.householdStat) {
        this.householdTotal = data.householdStat.peopleCount || 0
        this.householdStatisticsRate[0].value = data.householdStat.oldPeopleRatio || 0
        this.householdStatisticsRate[1].value = data.householdStat.babyPeopleRatio || 0
        this.householdStatisticsRate[2].value = data.householdStat.unKnowPeopleRatio || 0
        this.householdStatistics[0].value = data.householdStat.oldPeopleCount || 0
        this.householdStatistics[1].value = data.householdStat.babyPeopleCount || 0
        this.householdStatistics[2].value = data.householdStat.unKnowPeopleCount || 0
      }

      // 房屋概况
      if (data.buildingRoomStat) {
        this.HousesTotal = data.buildingRoomStat.buildingRoomCount || 0
        const keyNameRate = ['unSellRate', 'isSellRate', 'isGiveRate', 'isInRate', 'isHireRate', 'isEmptyRate']
        const keyName = ['unSell', 'isSell', 'isGive', 'isIn', 'isHire', 'isEmpty']
        keyNameRate.forEach((item, index) => {
          this.houseOverviewRate[index].value = data.buildingRoomStat[item] || 0
        })
        keyName.forEach((item, index) => {
          this.houseOverview[index].value = data.buildingRoomStat[item] || 0
        })
      }

      // 收费情况
      if (data.financeOrderStatDTO) {
        this.payList[0].amount = data.financeOrderStatDTO.onlinePayment
        this.payList[1].amount = data.financeOrderStatDTO.offlinePayment
        this.totalFeeAmount = 0
        this.payList.forEach(item => (this.totalFeeAmount += item.amount))
        this.feeSituation[0].amount = data.financeOrderStatDTO.thisYearReceived
        this.feeSituation[1].amount = data.financeOrderStatDTO.thisYearPreAmount
        this.feeSituation[2].amount = data.financeOrderStatDTO.thisYearRefund
        this.feeSituation[3].amount = data.financeOrderStatDTO.thisMonthReceived
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import './assets/css/charts.scss';
.chart-container {
  padding: vh(12.75) vw(25) vh(27);
  box-sizing: border-box;
  .countNumber {
    display: inline-block;
  }
  .ml-69 {
    margin-left: vw(69);
  }
  .mr-62 {
    margin-right: vw(62);
  }
  .mr-11 {
    margin-right: vw(11);
  }
  .chart-inner-content {
    flex-direction: column;
    width: 100%;
    height: 100%;
    color: #74a1e3;
    .top {
      background: linear-gradient(180deg, #ffffff 0%, #65bff0 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      text-fill-color: transparent;
    }
    .total {
      font-family: 'HarmonyOSSansSCBold';
      font-weight: 700;
      font-size: rem(22);
    }
    .unit {
      font-weight: 500;
      font-size: rem(14);
    }
    .text {
      margin-top: vh(4);
      font-size: rem(13);
    }
  }
  .title {
    font-size: rem(15);
    font-weight: 500;
    background: linear-gradient(180deg, #afccf7 2%, #74a1e3 96%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-fill-color: transparent;
  }
  .upperHalf {
    display: flex;
    .TopHalf {
      width: vw(510);
      height: vh(241);
      padding: vh(14) vw(20) vh(29);
      background: linear-gradient(90deg, rgba(3, 98, 227, 0.05) 9%, rgba(3, 98, 227, 0.06) 56%, rgba(3, 98, 227, 0.04) 100%);
      box-sizing: border-box;
      border: 1px solid rgba(182, 215, 253, 0.04);

      .detail {
        flex: 1;
        .item {
          color: #74a1e3;
          font-size: rem(13);
          .left {
            flex-shrink: 0;
            .icon {
              width: vw(18);
              height: vw(18);
            }
          }
          .line {
            width: vw(82);
            height: vh(0.5);
            margin-right: vw(19);
          }
          .right {
            flex: 1;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            margin-left: vw(20);
            background: linear-gradient(180deg, #ffffff 0%, #65bff0 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
            text-fill-color: transparent;
          }
          .amount {
            font-family: 'HarmonyOSSansSCBold';
            font-size: rem(20);
            font-weight: 700;
          }
          .unit {
            font-size: rem(14);
            font-weight: 500;
            margin-top: vh(2);
          }
        }
      }
    }
    .BottomHalf {
      width: vw(510);
      height: vh(413);
      padding: vh(14) vw(20);
      background: linear-gradient(90deg, rgba(3, 98, 227, 0.05) 9%, rgba(3, 98, 227, 0.06) 56%, rgba(3, 98, 227, 0.04) 100%);
      box-sizing: border-box;
      border: 1px solid rgba(182, 215, 253, 0.04);
    }
    .leftTopHalf {
      .chart {
        padding: 0 vw(6);
      }
      .totalDetail {
        flex-direction: column;
        width: vw(112);
        height: vw(112);
        box-shadow: inset 0px 0px 3px 0px #d5e4fc, inset 0px 0px 30px 0px #84bcff;
        border-radius: 9999px;
        text-align: center;
        color: #74a1e3;
        .top {
          background: linear-gradient(180deg, #ffffff 0%, #65bff0 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          text-fill-color: transparent;
        }
        .total {
          font-family: 'HarmonyOSSansSCBold';
          font-weight: 700;
          font-size: rem(24);
        }
        .unit {
          font-weight: 500;
          font-size: rem(14);
        }
        .text {
          margin-top: vh(6);
          color: #74a1e3;
          font-size: rem(13);
        }
      }
    }
    .leftBottomHalf {
      padding: vh(14) vw(14) vh(14) vw(20);
    }
    #chart-post {
      width: 100%;
      height: vh(332);
      padding-left: vw(6);
      box-sizing: border-box;
      display: grid;
      grid-template-columns: auto;
      .list {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        .left {
          display: flex;
          align-items: center;
          flex-shrink: 0;
          .label {
            font-size: rem(13);
            color: #74a1e3;
            margin-right: vw(8);
          }
        }
        .right {
          font-size: rem(14);
          font-weight: 500;
          background: linear-gradient(180deg, #ffffff 0%, #65bff0 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          text-fill-color: transparent;
          .value {
            font-size: rem(20);
            font-weight: 700;
            font-family: 'HarmonyOSSansSCBold';
          }
        }
      }
    }
    .centerHalf {
      width: vw(763);
      margin: 0 vw(45);
      .centerTopHalf {
        display: grid;
        grid-row-gap: vh(25);
        grid-column-gap: vw(65);
        grid-template-columns: auto auto auto auto;
        .groupDataItem {
          display: flex;
          align-items: flex-end;
          .icon {
            width: vw(28);
            height: vh(26);
            margin-right: vw(14);
          }
          .groupDataItem-left {
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            .amount {
              font-family: 'HarmonyOSSansSCBold';
              font-size: rem(28);
              margin-bottom: vh(4);
              background: linear-gradient(180deg, #ffffff 0%, #65bff0 100%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              background-clip: text;
              text-fill-color: transparent;
            }
            .unit {
              background: linear-gradient(180deg, #ffffff 0%, #65bff0 100%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              background-clip: text;
              text-fill-color: transparent;
              font-size: rem(14);
            }
            .title {
              font-size: rem(13);
              color: #74a1e3;
            }
          }
        }
      }
      .centerBottomHalf {
        position: relative;
        width: vw(763);
        height: vh(510);
      }
    }
    .rightHalf {
      .rightTopHalf {
        .chart {
          padding: 0 vw(32) 0 vw(6);
          .detail {
            .left {
              width: vw(68);
            }
          }
        }
        .houseHoldChart {
          width: 100%;
          height: 100%;
          border-radius: 50%;
          background: rgba(19, 141, 255, 0.01);
          box-shadow: inset 0px 0px vh(3) 0px #d6faff, inset 0px 0px vh(30) 0px #1dfaf3;
        }
      }
      .rightBottomHalf {
        .chart-service {
          width: 100%;
          height: vh(328);
          padding: 0 vw(6) 0;
          box-sizing: border-box;
          display: grid;
          grid-template-columns: auto;
          .list {
            justify-content: flex-start;
            .left {
              flex-shrink: 0;
              .label {
                font-size: rem(13);
                color: #74a1e3;
                margin-right: vw(8);
              }
            }
            .value {
              background: linear-gradient(180deg, #ffffff 0%, #65bff0 100%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              background-clip: text;
              text-fill-color: transparent;
              font-size: rem(20);
              font-weight: 700;
              .unit {
                font-weight: 500;
                font-size: rem(14);
              }
            }
          }
        }
      }
    }
  }
  .lowerPart {
    width: 100%;
    .lowerLeftPart {
      width: vw(1365);
      height: vh(301);
      padding: 0 vw(20);
      margin-right: vw(6);
      background: linear-gradient(90deg, rgba(3, 98, 227, 0.03) 5%, rgba(3, 98, 227, 0.06) 55%, rgba(3, 98, 227, 0.04) 100%);
      border: 1px solid rgba(182, 215, 253, 0.04);
      box-sizing: border-box;
      .left {
        flex: 1;
        margin: vh(14) 0 vh(24);
        .bottomLeft {
          margin: vh(13) vw(45) 0 vw(10);
          .situation {
            margin-bottom: vh(44);
            .item {
              display: flex;
              flex-direction: column;
              align-items: center;
              color: #74a1e3;
              font-size: rem(13);
              .amount {
                font-size: rem(24);
                font-weight: 700;
                font-family: 'HarmonyOSSansSCBold';
                background: linear-gradient(180deg, #ffffff 0%, #75c0ee 100%);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                background-clip: text;
                text-fill-color: transparent;
              }
              .unit {
                font-size: rem(14);
                font-weight: 500;
                background: linear-gradient(180deg, #ffffff 0%, #75c0ee 100%);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                background-clip: text;
                text-fill-color: transparent;
              }
            }
          }
          .charts {
            display: flex;
            justify-content: space-around;
            align-items: center;
          }
        }
      }
      .table::-webkit-scrollbar {
        /* WebKit browsers (Chrome, Safari) */
        display: none;
      }
      .table {
        position: relative;
        width: vw(770);
        height: vh(252);
        overflow-y: auto;
        scrollbar-width: none; /* Firefox */
        -ms-overflow-style: none; /* IE and Edge */
        margin: vh(24) 0;
        .empty {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: vh(35);
          img {
            width: vw(187);
            height: vh(176);
          }
        }
        .row {
          display: flex;
          align-items: center;
          width: vw(770);
          height: vh(36);
        }
        .rank {
          font-size: rem(17);
          font-weight: 500;
          color: #b3cdf9;
          font-style: oblique;
        }
        .row:nth-child(2n) {
          background: rgba(6, 41, 106, 0.56);
        }
        .firstly {
          color: #fd8031;
          position: relative;
        }
        .firstly::after {
          content: '';
          width: vw(20);
          height: vh(10);
          position: absolute;
          bottom: 0;
          left: vw(-4);
          filter: blur(2px);
          background: linear-gradient(89deg, rgba(181, 108, 62, 0) 0%, rgba(181, 108, 62, 0.67) 49%, rgba(181, 108, 62, 0) 99%);
        }
        .second {
          color: #16d8ff;
          position: relative;
        }
        .second::after {
          content: '';
          width: vw(20);
          height: vh(10);
          position: absolute;
          bottom: 0;
          left: vw(-4);
          filter: blur(2px);
          background: linear-gradient(89deg, rgba(59, 185, 252, 0) 0%, rgba(59, 185, 252, 0.67) 49%, rgba(59, 185, 252, 0) 99%);
        }
        .third {
          position: relative;
          color: #f7cd6c;
        }
        .third::after {
          content: '';
          width: vw(20);
          height: vh(10);
          position: absolute;
          bottom: 0;
          left: vw(-4);
          filter: blur(2px);
          background: linear-gradient(89deg, rgba(241, 187, 63, 0) 0%, rgba(241, 187, 63, 0.67) 49%, rgba(241, 187, 63, 0) 99%);
        }
        .column-1 {
          width: vw(206);
          text-align: left;
          padding-left: vw(28);
          box-sizing: border-box;
        }
        .column-2 {
          width: 36.62%;
          text-align: left;
        }
        .column-3 {
          width: 36.62%;
          text-align: end;
          padding-right: vw(19);
          box-sizing: border-box;
        }
        .gap {
          width: 100%;
          height: vh(36);
        }
        .table-header {
          display: flex;
          align-items: center;
          width: vw(770);
          height: vh(36);
          position: fixed;
          font-size: rem(14);
          color: #87b2f1;
          background: rgba(6, 41, 106, 0.56);
          z-index: 1;
        }
        .text {
          font-size: rem(14);
          color: #aecff3;
        }
        .color {
          background: linear-gradient(180deg, #ffffff 0%, #65bff0 96%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          text-fill-color: transparent;
        }
        .unit {
          font-size: rem(14);
        }
        .amount {
          font-size: rem(20);
          font-weight: 700;
        }
      }
    }
    .lowerRightPart {
      width: vw(510);
      height: vh(301);
      padding: vh(14) vw(20);
      background: linear-gradient(90deg, rgba(3, 98, 227, 0.05) 9%, rgba(3, 98, 227, 0.06) 56%, rgba(3, 98, 227, 0.04) 100%);
      box-sizing: border-box;
      border: 1px solid rgba(182, 215, 253, 0.04);
      .chart {
        width: 100%;
        box-sizing: border-box;
        padding: 0 vw(32) 0 vw(6);
      }
      .detail {
        .item {
          color: #74a1e3;
          font-size: rem(13);
          .left {
            display: flex;
            align-items: center;
            .dot {
              width: vw(7);
              height: vh(7);
              margin-right: vw(12);
              border-radius: 50%;
            }
          }
          .right {
            flex: 1;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            margin-left: vw(8);
            .line {
              width: vw(60);
              height: 0;
              border-top: 1px dashed rgba(255, 255, 255, 0.19);
              margin-right: vw(8);
            }
            .amount {
              font-family: 'HarmonyOSSansSCBold';
              font-weight: 700;
              font-size: rem(20);
              background: linear-gradient(180deg, #ffffff 0%, #65bff0 100%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              background-clip: text;
              text-fill-color: transparent;
            }
          }
        }
      }
      .context {
        border-radius: 9999px;
        text-align: center;
        color: #fff;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        .strip__wrapper {
          position: absolute;
          width: 100%;
          height: 100%;
          .strip {
            width: vw(2);
            height: vh(8);
            left: 50%;
            transform: translateX(-50%);
            background: #b7defd17;
            position: absolute;
            top: vh(4);
          }
        }
      }
    }
  }
}
</style>
